







import { Component, Prop, Vue, Emit, Watch } from 'vue-property-decorator';
import { uuid } from 'vue-uuid';

@Component({})
export default class TimePicker extends Vue {
  private id: string = '';
  private formatted: string = '';
  private tooltip: string = '';
  @Prop()
  private value!: string | null;
  @Prop({default: 'HH:mm'})
  private format!: string;
  @Prop({default: 'timepickerinput'})
  private appendClass!: string;
  @Prop({default: false})
  private disabled!: boolean;

  private alert: boolean = false;

  public created(): void {
    this.id = uuid.v1();
    this.apply();
  }

  private style(): any {
    const style: any = {
      disabled: this.disabled,
      alert: this.alert,
    };
    style[this.appendClass] = true;
    return style;
  }

  @Watch('value')
  private apply(): void {
    this.formatted = '';

    if (!this.value) {
      return;
    }

    this.formatted = this.value;
  }

  private textualFormat(event: Event): void {
    if (!this.value) {
      return;
    }

    if (this.value.match(/^[0-2][0-9]:[0-5][0-9]$/g)) {
      const hour = this.value.slice(0, 2);
      const minutes = this.value.slice(3, 5);
      this.formatted = hour + minutes;
      this.$nextTick(() => {
        const target = event.target as HTMLInputElement;
        target.select();
      });
      return;
    }

    this.alert = true;
    this.tooltip = '不正な時間です';
    this.formatted = this.value;
    this.$nextTick(() => {
      const target = event.target as HTMLInputElement;
      target.select();
    });
  }

  @Emit('input')
  private update(event: Event): string | null {
    this.alert = false;
    this.tooltip = '';

    const target = event.target as HTMLInputElement;
    if (!target.value) {
      return null;
    }

    if (target.value.match(/^[0-2][0-9](|:)[0-5][0-9]$/g)) {
      const time = target.value.replace(':', '');
      const hour = time.slice(0, 2);
      const minutes = time.slice(2, 4);

      if (Number(hour) < 24) {
        this.apply();
        return hour + ':' + minutes;
      }
    }
    this.alert = true;
    this.tooltip = '不正な時間です';
    this.$nextTick(() => {
      target.select();
    });
    return target.value;
  }
 }
